module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./indexView.js"));
	}, "LifeCouponFenNiaoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LifeCouponFenNiaoView!./src/pages/Shop/Member/Wallet/LifeCouponFenNiao/indexView.js
// module id = 1049
// module chunks = 438